import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getListEmergencyContact, deleteEmergencyContact } from '../../actions/emergencyContact';
import { withNamespaces } from 'react-i18next';
import * as StatusCode from '../../scripts/StatusCode';
import { IsEnglish } from '../../utils/language';
import LoadingLayer from '../controls/LoadingLayer';
import AlertAlgo from '../controls/AlertSnack';
import i18next from 'i18next';
import { toPhone } from '../../utils';
import Button from 'react-bootstrap-button-loader';
import Popup from '../controls/Popup';
import EmergencyContactForm from './EmergencyContactForm';
import styles from '../../styles/emergencyContact.module.css';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { isIOS } from '../../utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashXmark } from "@fortawesome/pro-duotone-svg-icons";

const useStyles = makeStyles((theme) => ({
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    row: {
        margin: '5px',
        display: 'table',
        whiteSpace: 'nowrap',
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        color: '#3f51b5 !important'
    },
}));

function EmergencyContact(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(true);
    const [openPop, setOpenPop] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [titlePop, setTitlePop] = useState('');
    const [emergencyContactId, setEmergencyContactId] = useState(0);
    const alertRef = useRef(null);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        loadList();
        resizeForm();
    }, []);

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - menu - offSet;

            const element = document.querySelector('#divEmergencyContact');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }

    const loadList = async () => {
        const response = await getListEmergencyContact();

        if (response != null && response.status == StatusCode.STATUS_OK) {
            setData(response.result);
            setIsProcessing(false);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
    }

    const handleAdd = (id) => {
        if (id > 0) {
            setEmergencyContactId(id);
            setTitlePop(i18next.t('emergencyContact:titleUpdate'));
        } else {
            setEmergencyContactId(0);
            setTitlePop(i18next.t('emergencyContact:titleInsert'));
        }

        setOpenPop(true);
    }

    const handleClosePop = () => {
        setOpenPop(false);
    }

    const handleCloseAdd = () => {
        showMessageSuccess(i18next.t('emergencyContact:message.success'));
        setOpenPop(false);
        loadList();
    }

    const handleDelete = async () => {
        if (emergencyContactId > 0) {
            const response = await deleteEmergencyContact(emergencyContactId);

            if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
                // Error
                showMessageError(i18next.t('error:generic-error'));
                return;
            }

            setOpenConfirmDelete(false);
            showMessageSuccess(i18next.t('emergencyContact:message.delete'));
            loadList();
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
    }

    const handleOpenConfirmDelete = (id) => {
        setEmergencyContactId(id);
        setOpenConfirmDelete(true);
    }

    const handleCloseConfirmDelete = () => {
        setOpenConfirmDelete(false);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (msg) => {
        alertRef.current.showMessageError(msg);
    }

    return (
        <div id="divEmergencyContact" className={styles.konekCard}>
            <LoadingLayer isActive={isProcessing}>
                {data && data.map((obj, index) =>
                    <React.Fragment key={index}>
                        <ListItem key={index} className="listItem" onClick={() => handleAdd(obj.id)}>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.priority')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.priority}
                                            </span>
                                        </span>
                                        <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.name')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.contactName}
                                            </span>
                                        </span>
                                        <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.relationship')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {IsEnglish() ? obj.relationshipE : obj.relationshipF}
                                            </span>
                                        </span>
                                        {obj.phoneOffice && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.phoneOffice')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {toPhone(obj.phoneOffice)}
                                            </span>
                                        </span>}
                                        {obj.extensionOffice && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.extension')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.extensionOffice}
                                            </span>
                                        </span>}
                                        {obj.phone && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.phone')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {toPhone(obj.phone)}
                                            </span>
                                        </span>}
                                        {obj.cellphone && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.cellphone')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {toPhone(obj.cellphone)}
                                            </span>
                                        </span>}
                                        {obj.email && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.email')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.email}
                                            </span>
                                        </span>}
                                        {obj.other && <span className={classes.row}>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('emergencyContact:list.comment')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.other}
                                            </span>
                                        </span>}
                                    </React.Fragment>
                                }
                            />
                            <ListItemSecondaryAction className={classes.divAction}>
                                <IconButton className={classes.icons} edge="end" aria-label="delete" onClick={() => handleOpenConfirmDelete(obj.id)}>
                                    <FontAwesomeIcon icon={faTrashXmark} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </React.Fragment>
                )}

                <Popup title={titlePop} openPop={openPop} handleClosePop={handleClosePop}>
                    <EmergencyContactForm id={emergencyContactId} handleClose={handleCloseAdd} />
                </Popup>
                <AlertAlgo ref={alertRef} />

                <Fab color="primary" aria-label="add" className={`addButtonFab ${isiOS && "addButtonFabIOS"}`} onClick={() => handleAdd()} >
                    <AddIcon />
                </Fab>
            </LoadingLayer>

            <Dialog
                open={openConfirmDelete}
                onClose={handleCloseConfirmDelete}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Confirmation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('common:confirmDelete')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => handleDelete()} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                    <Button onClick={handleCloseConfirmDelete} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withNamespaces(['emergencyContact', 'error'], { wait: true })(EmergencyContact);